import React from 'react';
import { connect } from 'react-redux';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';

import CertificateIcon from '../../../components/certificate-icon/certificate-icon';
import css from './rank-tiles.scss';
import { capitalise } from '../../../helpers/utils';

const Tile = ({ total, rank, localeData }) => {
    const classes = total > 0 ? css.tile : `${css.tile} ${css['no-certificates']}`;
    const totalScore = total > 0 ? total.toString() : '-';
    const rankLabel = capitalise(rank);
    const rankTrans = localeData[`Label - ${rankLabel}`];
    return (
        <div className={classes}>
            <div className={css.content}>
                <CertificateIcon rank={rank} className={css['rank-icon']} total={total} />
                <div className={css.rank}>{rankTrans}</div>
                <div className={css.total}>{totalScore}</div>
            </div>
        </div>
    );
};

Tile.propTypes = {
    total: PropTypes.number,
    rank: PropTypes.string,
    localeData: PropTypes.object
};


function mapStateToProps(state) {
    return {
        localeData: state.localeData
    };
}

export default connect(mapStateToProps, null)(styleable(css)(Tile));



// WEBPACK FOOTER //
// ./containers/participation-report/sub-components/tile.js